export class CoordinatesHelper {
    static normalizeCoord(coord) {
        return coord.replace("\n", "").replace(/\s+/g, "");
    }

    static toArrayWrapper(str) {
        return "[" + str + "]";
    }

    static parseToArray(str) {
        return JSON.parse(str);
    }
}
